<template>
    <div class="content-wrapper-scroll">
        <div class="content-wrapper">
            <div class="row">
                <div class="col-sm-4">
                    <div class="card">
                        <div class="card-header">
                            <h5>New Frequency</h5>
                        </div>
                        <div class="card-body">
                            <div class="field-wrapper">
                                <input class="form-control" type="text" :class="{'is-invalid': errors.frequency_name}" placeholder="Frequency Name" v-model="frequency.frequency_name" ref="frequency_name" />
                                <span v-if="errors.frequency_name" class="invalid-feedback">{{ errors.frequency_name[0] }}</span>
                                <div class="field-placeholder">Frequency Name <span class="text-danger">*</span></div>
                               
                            </div>
							<div class="field-wrapper">
                                <input class="form-control" type="text" :class="{'is-invalid': errors.no_of_days}" placeholder="No of Days" v-model="frequency.no_of_days" ref="no_of_days" />
                                <span v-if="errors.no_of_days" class="invalid-feedback">{{ errors.no_of_days[0] }}</span>
                                <div class="field-placeholder">No of Days <span class="text-danger">*</span></div>
                              
                            </div>
                            <div class="field-wrapper">
                                <textarea class="form-control" rows="2" :class="{'is-invalid': errors.description}" placeholder="Description" v-model="frequency.description" ref="description"></textarea>
                                <span v-if="errors.description" class="invalid-feedback">{{ errors.description[0] }}</span>
                                <div class="field-placeholder">Description <span class="text-danger">*</span></div>
                               
                            </div>
                            <div class="form-actions-footer">
                                <div class="text-end">
                                    <button class="btn btn-danger" @click="reset">Discard</button>
                                    <button  v-can="'frequencies.create'" class="btn btn-primary ms-1" v-if="status" @click="addfrequency">Submit</button>
                                    <button  v-can="'frequencies.update'"  class="btn btn-primary ms-1" v-else @click="updatefrequency">Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-8">
                    <div class="card">
                        <div class="card-header">
                            <h5>Frequencies</h5>
                        </div>
                        <div class="card-body">
                            <div class="col-sm-12">
                                <div class="input-group">
                                    <input class="form-control" type="text" placeholder="Type here and press enter to search" v-model="meta.search" @keyup.enter="search">
                                    <span class="input-group-text">
                                        <i class="fas fa-search"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="table-responsive" style="margin-top: 10px;">
                                <table class="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th @click="sort('frequency_name')">
                                                Name
                                            <span>
                                                    <i v-if="meta.field=='frequency_name' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field=='frequency_name' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                            </span>
                                            </th>
											<th @click="sort('no_of_days')">
                                                No of Days
                                            <span>
                                                    <i v-if="meta.field=='no_of_days' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field=='no_of_days' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                            </span>
                                            </th>
                                            <th @click="sort('description')">
                                                Description
                                            <span>
                                                    <i v-if="meta.field=='description' && meta.order_by=='asc'" class="fas fa-sort-up"></i>
                                                    <i v-else-if="meta.field=='description' && meta.order_by=='desc'" class="fas fa-sort-down"></i>
                                                    <i v-else class="fas fa-sort"></i>
                                            </span>
                                            </th>
                                            <th>
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                         <tr v-if="frequencies.length==0">
                                            <td  colspan="8" class="text-center">No records found</td>
                                        </tr>
                                        <tr v-for="(frequency,key) in frequencies" :key="frequency.frequency_id">
                                            <td>{{ meta.from+key }}</td>
                                            <td>{{ frequency.frequency_name }}</td>
											<td>{{ frequency.no_of_days }}</td>
                                            <td>{{ frequency.description }}</td>
                                            <td class="td-actions">
                                                <a href="#"  v-can="'frequencies.update'"  class="icon green" @click.prevent="edit(frequency)">
                                                    <i class="icon-pencil"></i>
                                                </a>
                                                <a href="#"  v-can="'frequencies.delete'"  class="icon red" @click.prevent="deletefrequency(frequency.frequency_id)">
                                                    <i class="icon-cancel"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                           </div>
                            <div class="form-actions-footer">
                                    <div class="text-end row">
                                        <div class="col-sm-2">
                                            <select class="form-control" v-model="meta.per_page" @change="onPerPageChange">
                                                <option>10</option>
                                                <option>15</option>
                                                <option>20</option>
                                                <option>25</option>
                                                <option>30</option>
                                            </select>
                                        </div>
                                        <div class="col-sm-10">
                                            <Pagination class="pagination pagination-sm" :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.currentPage" @pagechanged="onPageChange" />
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    export default {
        components: { Pagination },
        data() {
            return {
                status: true,
                frequency: {
                    frequency_id: "",
                    frequency_name: "",
					no_of_days:"",
                    description: "",
                },
                errors: [],
                frequencies: [],
                meta: {
                    search: "",
                    order_by: "asc",
                    field: "frequency_name",
                    per_page: 10,
                    totalRows: 0,
                    currentPage: 1,
                    lastPage: 1,
                    from: 1,
                    maxPage: 1,
                },
            };
        },
        mounted() {
            this.index();
        },
        methods: {
            index() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = "frequencies?page=" + vm.meta.currentPage + "&search=" + vm.meta.search + "&order_by=" + vm.meta.order_by + "&field=" + vm.meta.field + "&per_page=" + vm.meta.per_page;
                vm.$store.dispatch("post", { uri: uri })
				.then(function (response) {
					loader.hide();
					vm.frequencies = response.data.data;
					vm.meta.totalRows = response.data.total;
					vm.meta.lastPage = response.data.last_page;
					vm.meta.from = response.data.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
				})
				.catch(function (error) {
                    loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
            },

            addfrequency() {
                let vm = this;
                let loader = vm.$loading.show();
                vm.$store.dispatch("post", { uri: "addFrequency", data: vm.frequency })
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "frequency Added successfully");
					vm.reset();
					vm.errors = [];
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
            },

            updatefrequency() {
                let vm = this;
                let loader = vm.$loading.show();
                let uri = { uri: "updateFrequency/" + vm.frequency.frequency_id, data: vm.frequency };
                vm.$store.dispatch("patch", uri)
				.then(function () {
					loader.hide();
					vm.$store.dispatch("success", "frequency is successfully updated");
					vm.reset();
					vm.errors = [];
				})
				.catch(function (error) {
					loader.hide();
					vm.errors = error.response.data.errors;
					vm.$store.dispatch("error", error.response.data.message);
				});
            },

            deletefrequency(frequencies) {
                let vm = this;
                if (confirm("Do you want to delete this entry ?")) {
                    let loader = vm.$loading.show();
                    let uri = { uri: "deleteFrequency/" + frequencies };
                    vm.$store.dispatch("delete", uri)
					.then(function () {
						loader.hide();
						vm.$store.dispatch("success", "frequency is successfully deleted");
						vm.reset();
                        
					})
					.catch(function (error) {
						loader.hide();
						vm.errors = error.response.data.errors;
						vm.$store.dispatch("error", error.response.data.message);
					});
                }
            },

            edit(frequency) {
                let vm = this;
                (vm.frequency = frequency), (vm.status = false), vm.$refs.frequency_name.focus();
            },

            reset() {
                let vm = this;
                vm.frequency.frequency_name = "";
				vm.frequency.no_of_days = "";
                vm.frequency.description = "";
                vm.$refs.frequency_name.focus();
                vm.index();
                vm.errors = [];
                vm.status = true;
            },

            onPageChange(page) {
                this.meta.currentPage = page;
                this.index();
            },

            onPerPageChange() {
                this.meta.currentPage = 1;
                this.index();
            },
            sort(field) {
                this.meta.field = field;
                this.meta.order_by = this.meta.order_by=='asc' ? 'desc' : 'asc';
                this.index();
            },
            search() {
				let vm = this;
                vm.meta.currentPage=1;
                vm.index();
			}  
        },
    };
</script>
